module.exports = __webpack_public_path__ + "static/media/S2N8-4.82b75c14.svg";